import { SxProps } from '@mui/material'

interface DividerStyles {
  dividerStyles: SxProps
}

export const dividerStyles: DividerStyles = {
  dividerStyles: {
    width: '100%',
    height: '1px',
    backgroundColor: 'utils.gray300',
  },
}
